<template>
  <z-card v-if="displayGroups.length" :class="ns.b()" shadow="never">
    <template #header>
      <span :class="ns.e('title')">{{ t('z.rules.summaryTitle') }}</span>
    </template>
    <p :class="ns.e('text')">{{ summaryText }}</p>
    <div :class="ns.e('tags')">
      <template v-for="(group, groupIndex) in displayGroups" :key="group.id">
        <span v-if="groupIndex > 0" :class="ns.e('logic')">
          {{ t(`z.table.logic.${group.groupLogic}`) }}
        </span>
        <span
          v-if="group.conditions.length > 1"
          :class="[ns.e('bracket'), ns.is('open', true)]"
        >
          (
        </span>
        <template v-for="(cond, condIndex) in group.conditions" :key="cond.id">
          <span v-if="condIndex > 0" :class="ns.e('logic')">
            {{ t(`z.table.logic.${cond.logic}`) }}
          </span>
          <z-tag :class="ns.e('tag')" size="small" type="info">
            {{ formatCondition(cond) }}
          </z-tag>
        </template>
        <span
          v-if="group.conditions.length > 1"
          :class="[ns.e('bracket'), ns.is('close', true)]"
        >
          )
        </span>
      </template>
    </div>
  </z-card>
  <z-card v-else :class="[ns.b(), ns.is('empty', true)]" shadow="never">
    <template #header>
      <span :class="ns.e('title')">{{ t('z.rules.summaryTitle') }}</span>
    </template>
    <p :class="ns.e('placeholder')">{{ t('z.rules.summaryEmpty') }}</p>
  </z-card>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ZCard from '@zoryn/components/card'
import ZTag from '@zoryn/components/tag'
import { useLocale, useNamespace } from '@zoryn/hooks'
import {
  buildRuleDisplayGroups,
  formatRuleDisplayText,
  type RuleDisplayCondition,
} from './rule-display'
import type { RuleGroupState, SystemParamField } from './rules'

const props = defineProps<{
  ruleGroups: RuleGroupState[]
  fieldList: SystemParamField[]
}>()

const ns = useNamespace('rules-summary')
const { t } = useLocale()

const displayGroups = computed(() =>
  buildRuleDisplayGroups(props.ruleGroups, props.fieldList, t)
)

const summaryText = computed(() => formatRuleDisplayText(displayGroups.value, t))

function formatCondition(cond: RuleDisplayCondition) {
  if (cond.valueLabel) {
    return `${cond.columnTitle} ${cond.operatorLabel} ${cond.valueLabel}`
  }
  return `${cond.columnTitle} ${cond.operatorLabel}`
}
</script>
